// Takes a PBS-served IANA time zone code, returns a string formatted for display
// (this function translated from the python version in core/time_zones.py)
export const formatTimezones = (timezoneCode: string): string => {
  // this hard-coded list represents the time zones as they are currently returned from station manager
  const displayTimezones = [
    {
      code: "America/New_York",
      displayName: "Eastern"
    },
    {
      code: "America/Chicago",
      displayName: "Central"
    },
    {
      code: "America/Denver",
      displayName: "Mountain"
    },
    // Indiana, the state, has some counties that fall in the Central time zone,
    // however, Indianapolis falls in the Eastern Time Zone
    {
      code: "America/Indiana/Indianapolis",
      displayName: "Eastern"
    },
    {
      code: "America/Los_Angeles",
      displayName: "Pacific"
    },
    {
      code: "America/Anchorage",
      displayName: "Alaska"
    },

    // According to https://www.timeanddate.com/time/zone/usa/arizona
    // Arizona only observes Mountain Standard Time, regardless of DST
    {
      code: "America/Phoenix",
      displayName: "Mountain Std"
    },
    // The rest of these locations do not observe DST
    {
      code: "Pacific/Honolulu",
      displayName: "Hawaii"
    },
    {
      code: "America/Puerto_Rico",
      displayName: "Atlantic"
    },
    {
      code: "America/St_Thomas",
      displayName: "Atlantic"
    },
    {
      code: "Pacific/Guam",
      displayName: "Chamorro"
    },
    {
      code: "Pacific/Pago_Pago",
      displayName: "Samoa"
    }
  ];

  return displayTimezones.find((timezone) => timezoneCode === timezone.code)!.displayName;
}
